import { IEmotionRecordDTO } from "motw_core/DTOs/IEmotionRecordDTO";
import * as React from "react";
import ReactTooltip from "react-tooltip";
import { DisplayEmotionRecord } from "source/app/presentation/MainPanel/KeyValueLogs/PercentValue/Grouped/Record/DisplayEmotionRecord";
import { DisplayFetchingData } from "source/app/presentation/Shared/Loading/DisplayFetchingData";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { EmotionChart } from "source/app/presentation/MainPanel/KeyValueLogs/PercentValue/Grouped/Chart/EmotionChart";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ToggleEmotionValuesTimePeriod } from "./ToggleEmotionValuesTimePeriod";

export function ShowEmotionValues() {
    const [emotionRecords, setEmotionRecords] = React.useState<
        IEmotionRecordDTO[] | undefined
    >(undefined);

    const [timePeriod, setTimePeriod] =
        React.useState<EEmotionRecordTimePeriod>(
            EEmotionRecordTimePeriod.Daily
        );

    React.useEffect(() => {
        setEmotionRecords(undefined);
        LoadEmotionRecordsAsync(timePeriod, setEmotionRecords);
        ReactTooltip.rebuild();
    }, [timePeriod]);

    const containerStyleClass = StyleClass(`emotionMonthValuesContainer`, {
        margin: "0",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        textAlign: `center`,
        width: "90%",
        marginLeft: `12px`,
    });

    if (emotionRecords === undefined) {
        return (
            <div style={{ padding: `15px` }}>
                <DisplayFetchingData />
            </div>
        );
    }

    return (
        <div className={containerStyleClass}>
            <EmotionChart {...{ emotionRecords }} />
            <ToggleEmotionValuesTimePeriod
                timePeriod={timePeriod}
                setTimePeriod={setTimePeriod}
            />
            <div>
                {emotionRecords.map((er, index) => (
                    <DisplayEmotionRecord
                        emotionRecord={er}
                        key={er.timePeriodDescription}
                        isFirstRecord={index === 0}
                        isLastRecord={index === emotionRecords.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}

async function LoadEmotionRecordsAsync(
    timePeriod: EEmotionRecordTimePeriod,
    setEmotionRecords: React.Dispatch<React.SetStateAction<IEmotionRecordDTO[]>>
) {
    let emotionRecords: IEmotionRecordDTO[];

    switch (timePeriod) {
        case EEmotionRecordTimePeriod.Daily:
            emotionRecords = await MotwLogicServer.DailyEmotions();
            break;

        case EEmotionRecordTimePeriod.Weekly:
            emotionRecords = await MotwLogicServer.WeeklyEmotions();
            break;

        case EEmotionRecordTimePeriod.Monthly:
            emotionRecords = await MotwLogicServer.MonthlyEmotions();
            break;

        default:
            break;
    }

    const pastRecords = emotionRecords!.filter((er) => er.isPeriodComplete);

    setEmotionRecords(pastRecords);
    ReactTooltip.rebuild();
}

export enum EEmotionRecordTimePeriod {
    Daily,
    Weekly,
    Monthly,
}
